import type { Common } from '@libs/domain';
import type { CharacterCode } from '@libs/enums';
import { characterCode } from '@libs/enums';
import type { OrEmpty } from '@ps-smart-cp/ppfw-client';

export class ImportFileField implements Pick<Common['schema'], 'characterCode' | 'file'> {
  /**
   *
   * @param file ファイル
   * @param characterCode 文字コード
   *
   */
  private constructor(
    readonly file: File | null,
    readonly characterCode: OrEmpty<CharacterCode>,
  ) {}

  static init() {
    return new ImportFileField(null, characterCode.enum.ms932);
  }
}

export class ImportFileFieldRaw implements Pick<Common['record'], 'characterCode' | 'file'> {
  private constructor(
    readonly file: string,
    readonly characterCode: string,
  ) {}

  static fromModel(model: ImportFileField, fileURL: string) {
    return new ImportFileFieldRaw(fileURL, model.characterCode);
  }
}
